var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    rx: 12,
    fill: "#5A83B8",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9186 24.9355C42.9186 27.3054 41.9772 29.5782 40.3015 31.2539C38.6257 32.9297 36.3529 33.8711 33.9831 33.8711C31.6132 33.8711 29.3404 32.9297 27.6647 31.2539C25.989 29.5782 25.0475 27.3054 25.0475 24.9355C25.0475 22.5657 25.989 20.2929 27.6647 18.6172C29.3404 16.9414 31.6132 16 33.9831 16C36.3529 16 38.6257 16.9414 40.3015 18.6172C41.9772 20.2929 42.9186 22.5657 42.9186 24.9355ZM58.0197 39.4219C57.6845 39.254 57.305 39.1957 56.9349 39.2554C56.5648 39.315 56.2228 39.4895 55.9574 39.7543L42.697 56.5888L33.1896 46.6811C32.8463 46.4526 32.4346 46.3498 32.0242 46.3902C31.6138 46.4305 31.23 46.6116 30.9379 46.9027L17.9062 62.4648V69.6133C17.9062 70.5612 18.2828 71.4703 18.9531 72.1406C19.6234 72.8109 20.5325 73.1875 21.4805 73.1875H71.5195C71.9889 73.1875 72.4537 73.0951 72.8873 72.9154C73.321 72.7358 73.715 72.4725 74.0469 72.1406C74.3788 71.8087 74.6421 71.4147 74.8217 70.9811C75.0013 70.5474 75.0938 70.0827 75.0938 69.6133V53.5293L58.0197 39.4219Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/imageIcon.81122381bbb8aa7bea40b5a21fb9adb0.svg";
export { ForwardRef as ReactComponent };